import { HTTP } from '../../services/baseHttpSvc';
import _ from 'lodash';
import { convertAnyWho5AssessmentsToPositiveBaseScore } from '@/utilities/convertWho5Scores.js';

require('promise.prototype.finally').shim();

const initialSupervisorFilters = {
  // the id of selected coach
  coachId: null,
  // Number of days within which a supervisor interaction has occurred
  lastSupervisorReviewedDays: null
};

const state = {
  coachingSupervisorFilters: Object.assign({}, initialSupervisorFilters),
  // indicator if coaching supervisor call is in-progress
  coachingSupervisorLoading: false,
  coachingSupervisorPatients: {
    supervisorPatients: []
  }
};

const getters = {
  coachingSupervisorFilters: state => state.coachingSupervisorFilters,
  hasCoachingSupervisorFilters: state => {
    if (
      !_.isEmpty(state.coachingSupervisorFilters) &&
      (state.coachingSupervisorFilters.coachId ||
        state.coachingSupervisorFilters.lastSupervisorReviewedDays !== null)
    ) {
      return true;
    }
    return false;
  },
  coachingSupervisorPatients: state => state.coachingSupervisorPatients,
  coachingSupervisorLoading: state => state.coachingSupervisorLoading
};

const actions = {
  getCoachingSupervisorPatients(context) {
    context.commit('setCoachingSupervisorLoading', true);
    return HTTP.post(
      '/patients/search/coaching-supervisor',
      getFilterParams(
        context.getters.coachingSupervisorFilters,
        context.getters.coachingDashboardSettings
      )
    )
      .then(response => {
        for (let patient of response.data.supervisorPatients) {
          convertAnyWho5AssessmentsToPositiveBaseScore(patient.assessmentScores);
        }

        context.commit('setCoachingSupervisorPatients', response.data);
        context.commit('setCoachingSupervisorLoading', false);
      })
      .finally(() => context.commit('setCoachingSupervisorLoading', false));
  },
  setPatientSupervisorReview(context, userId) {
    return HTTP.patch(`/coaching/user/${userId}/review`).then(() => {
      context.commit('setSingleSupervisorPatient', userId);
    });
  }
};

const mutations = {
  setCoachingSupervisorFilters(state, filters) {
    if (filters && Object.keys(filters).length > 0) {
      // merge filters with coachingFilters. filters wins if there are any collisions.
      state.coachingSupervisorFilters = {
        ...state.coachingSupervisorFilters,
        ...filters
      };
    } else {
      // reset to initial state
      state.coachingSupervisorFilters = initialSupervisorFilters;
    }
  },
  setCoachingSupervisorLoading(state, loading) {
    state.coachingSupervisorLoading = loading;
  },
  setCoachingSupervisorPatients(state, patientArray) {
    state.coachingSupervisorPatients = patientArray;
  },
  setSingleSupervisorPatient(state, userId) {
    const patients = state.coachingSupervisorPatients.supervisorPatients;
    let patient = {
      index: null,
      record: {}
    };

    // For loop for perf and ability to stop loop
    for (let index = 0; index < patients.length; index++) {
      const item = patients[index];
      if (item.id === userId) {
        patient.index = index;
        patient.record = item;
        break;
      }
    }

    // Only update single record
    if (patient.index !== null) {
      patient.record.supervisorReviewDate = new Date().getTime();
      state.coachingSupervisorPatients.supervisorPatients[patient.index] =
        patient.record;
    }
  }
};

function getFilterParams(filters, pageSettings) {
  return {
    coachId: filters.coachId,
    page: pageSettings.page,
    rowCount: pageSettings.pageSize,
    lastReviewedDays: filters.lastSupervisorReviewedDays,
    assessmentSeverity: [],
    currentFocus: [],
    lastInteractionDays: null,
    userStatus: filters.coachingStatus
  };
}

export default {
  state,
  getters,
  actions,
  mutations
};
